//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { getAgeFromDate, formatDate } from '@tmt-insights/oms_fe_core/date';
import { DateTimeDisplay, History, OverflowMenu, TableStatus, TaskResolve } from '@tmt-insights/oms_fe_core/columns';
import { AllTableColumnsConfig } from '@/__configs/config_types';
import { OrderJobTask, TitleEntity } from '@/redux/slices/slice_types';

const columns: AllTableColumnsConfig<OrderJobTask> = {
  hid: {
    label: 'Task ID',
    sortField: 'id',
    render: (cell: OrderJobTask['hid']) => <strong>{cell}</strong>
  },
  job__due_date: {
    label: 'Due Date',
    minWidth: 100,
    render: (cell: OrderJobTask['job']['due_date']) => formatDate(cell)
  },
  created_at_dateformat: {
    sortField: 'created_at',
    label: 'Created',
    minWidth: 120,
    render: (_cell: OrderJobTask['created_at'], row: OrderJobTask) => <DateTimeDisplay>{row.created_at}</DateTimeDisplay>
  },
  created_at: {
    label: 'Age',
    minWidth: 120,
    render: (cell: OrderJobTask['created_at']) => getAgeFromDate(cell)
  },
  job__id: {
    label: 'Related Job',
    render: (cell: OrderJobTask['job']['id']) => (
      <a href={`/jobs/${cell}`} style={{ textDecoration: 'none', color: 'var(--primary-main)' }}>
        <strong>J{cell}</strong>
      </a>
    )
  },
  job__title__name: {
    label: 'Title',
    render: (cell: TitleEntity['name']) => <strong>{cell}</strong>
  },
  job__version__program_id: {
    label: 'Program ID'
  },
  job__version__piece_id: {
    label: 'Piece ID'
  },
  job__version__piece_number: {
    label: 'Piece Number'
  },
  status: {
    label: 'Status',
    minWidth: 170,
    render: (cell: OrderJobTask['status'], row: OrderJobTask) => {
      return <TableStatus status={cell} labelOverride={row.pretty_name} statusReason={row.status_reason} />;
    }
  },
  overflow: {
    label: '',
    isOverflow: true,
    render: (_cell: any, row: OrderJobTask) => (
      <OverflowMenu>
        <History data={row} />
        {!!row.status_reason && row.status !== 'resolved' && <TaskResolve task={row} />}
      </OverflowMenu>
    )
  }
};

export default columns;
